import React from "react"
import { RouteObject } from "react-router"
import studyRouteNames from "src/pages/study/study-route-names"
import { Crumb } from "src/pages/study/components/breadcrumbs"
import { RouteHandle } from "src/pages/study/create-study-routes"
import { Redirect } from "src/router/routes"

export const createReportRoutes = (): RouteObject[] => {
  return [
    {
      path: studyRouteNames.reports.route,
      lazy: () => import("src/pages/study/reports/reports-layout"),
      handle: {
        crumb: ({ to, disabled }) => (
          <Crumb
            to={to}
            disabled={disabled}
            messageId="sponsorStudyNav.reports"
          />
        ),
      } satisfies RouteHandle,
      children: [
        {
          path: studyRouteNames.surveyDataReport.route,
          lazy: () => import("src/pages/study/reports/report/report"),
        },
        {
          path: studyRouteNames.participantEventsReport.route,
          lazy: () => import("src/pages/study/reports/report/report"),
        },
        {
          path: studyRouteNames.participantGroupsReport.route,
          lazy: () => import("src/pages/study/reports/report/report"),
        },
        {
          path: studyRouteNames.complianceReport.route,
          lazy: () => import("src/pages/study/reports/report/report"),
        },
        {
          path: studyRouteNames.sponsorAuditReport.route,
          lazy: () => import("src/pages/study/reports/report/report"),
        },
        {
          path: studyRouteNames.siteUserActionReport.route,
          lazy: () => import("src/pages/study/reports/report/report"),
        },
        {
          path: studyRouteNames.siteClinicalDataReport.route,
          lazy: () => import("src/pages/study/reports/report/report"),
        },
        {
          path: studyRouteNames.dataChangesReport.route,
          lazy: () => import("src/pages/study/reports/report/report"),
        },
        {
          path: studyRouteNames.ruleReport.route,
          lazy: () => import("src/pages/study/reports/report/report"),
        },
        {
          path: studyRouteNames.customExportReport.route,
          lazy: () => import("src/pages/study/reports/report/report"),
        },
        {
          index: true,
          element: <Redirect to={studyRouteNames.surveyDataReport.route} />,
        },
      ],
    },
  ]
}
